import { render } from "./ReferencesNew.vue?vue&type=template&id=fbe2ffac&scoped=true"
import script from "./ReferencesNew.vue?vue&type=script&lang=js"
export * from "./ReferencesNew.vue?vue&type=script&lang=js"

import "./ReferencesNew.vue?vue&type=style&index=0&id=fbe2ffac&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe2ffac"]])

export default __exports__